function generateDefaultInitialHydraHomePageComponentsState() {
  return {
    hydraHomePageComponents: null,
    hydraHomePageMobileComponents: null,
    hydraHomePageMobileLazyComponent: null,
  };
}

function hydraHomePageComponentsReducer(
  state = generateDefaultInitialHydraHomePageComponentsState(),
  action
) {
  let newState;
  switch (action.type) {
    case 'GET_HYDRA_HOME_PAGE_COMPONENTS_FULFILLED': {
      newState = {
        ...state,
        hydraHomePageComponents: action.payload.response.data.result
      };

      break;
    }

    case 'GET_HYDRA_HOME_PAGE_MOBILE_COMPONENTS_FULFILLED': {
      newState = {
        ...state,
        hydraHomePageMobileComponents: action.payload.response.data
      };

      break;
    }

    case 'GET_HYDRA_HOME_PAGE_MOBILE_LAZY_COMPONENT_FULFILLED': {
      newState = {
        ...state,
        hydraHomePageMobileLazyComponent: action.payload.response.data
      };

      break;
    }

    default:
      newState = state;
  }

  return newState;
}

export default hydraHomePageComponentsReducer;
export {generateDefaultInitialHydraHomePageComponentsState};
